__turbopack_context__.v({
  "UiSwitch": "switch-module__-t5v8q__UiSwitch",
  "UiSwitchCard": "switch-module__-t5v8q__UiSwitchCard",
  "UiSwitchCard__checked": "switch-module__-t5v8q__UiSwitchCard__checked" + " " + "switch-module__-t5v8q__UiSwitchCard",
  "UiSwitchCard__default": "switch-module__-t5v8q__UiSwitchCard__default" + " " + "switch-module__-t5v8q__UiSwitchCard",
  "UiSwitchCard__input": "switch-module__-t5v8q__UiSwitchCard__input",
  "UiSwitchCard__label": "switch-module__-t5v8q__UiSwitchCard__label",
  "UiSwitchCard__label__description": "switch-module__-t5v8q__UiSwitchCard__label__description",
  "UiSwitchCard__label__value": "switch-module__-t5v8q__UiSwitchCard__label__value",
  "UiSwitchCard__suffix": "switch-module__-t5v8q__UiSwitchCard__suffix",
  "UiSwitchCard__thumbnail": "switch-module__-t5v8q__UiSwitchCard__thumbnail",
  "UiSwitchIcon": "switch-module__-t5v8q__UiSwitchIcon",
  "UiSwitchIcon__CheckIcon": "switch-module__-t5v8q__UiSwitchIcon__CheckIcon",
  "UiSwitchIcon__CheckIcon__checked": "switch-module__-t5v8q__UiSwitchIcon__CheckIcon__checked" + " " + "switch-module__-t5v8q__UiSwitchIcon__CheckIcon",
  "UiSwitchIcon__CheckIcon__default": "switch-module__-t5v8q__UiSwitchIcon__CheckIcon__default" + " " + "switch-module__-t5v8q__UiSwitchIcon__CheckIcon",
  "UiSwitchIcon__CheckIcon__icon": "switch-module__-t5v8q__UiSwitchIcon__CheckIcon__icon",
  "UiSwitch__checked": "switch-module__-t5v8q__UiSwitch__checked" + " " + "switch-module__-t5v8q__UiSwitch",
  "UiSwitch__default": "switch-module__-t5v8q__UiSwitch__default" + " " + "switch-module__-t5v8q__UiSwitch",
  "UiSwitch__input": "switch-module__-t5v8q__UiSwitch__input",
  "UiSwitch__label": "switch-module__-t5v8q__UiSwitch__label",
  "UiSwitch__label__description": "switch-module__-t5v8q__UiSwitch__label__description",
  "UiSwitch__label__value": "switch-module__-t5v8q__UiSwitch__label__value",
  "UiSwitch__suffix": "switch-module__-t5v8q__UiSwitch__suffix",
});
